/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_List_Name_LabelInputs */

const en_markers_list_name_label = /** @type {(inputs: Markers_List_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`List Name`)
};

const fr_markers_list_name_label = /** @type {(inputs: Markers_List_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom de la liste`)
};

const de_markers_list_name_label = /** @type {(inputs: Markers_List_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listenname`)
};

const it_markers_list_name_label = /** @type {(inputs: Markers_List_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome elenco`)
};

const ru_markers_list_name_label = /** @type {(inputs: Markers_List_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Название списка`)
};

const es_markers_list_name_label = /** @type {(inputs: Markers_List_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre de la lista`)
};

const zh_cn2_markers_list_name_label = /** @type {(inputs: Markers_List_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`列表名称`)
};

const ja_markers_list_name_label = /** @type {(inputs: Markers_List_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リスト名`)
};

const hi_markers_list_name_label = /** @type {(inputs: Markers_List_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नाम की सूचि`)
};

const pt_pt2_markers_list_name_label = /** @type {(inputs: Markers_List_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome da lista`)
};

/**
* | output |
* | --- |
* | "List Name" |
*
* @param {Markers_List_Name_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_list_name_label = /** @type {((inputs?: Markers_List_Name_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_List_Name_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_markers_list_name_label(inputs)
	if (locale === "de") return de_markers_list_name_label(inputs)
	if (locale === "it") return it_markers_list_name_label(inputs)
	if (locale === "ru") return ru_markers_list_name_label(inputs)
	if (locale === "es") return es_markers_list_name_label(inputs)
	if (locale === "zh-CN") return zh_cn2_markers_list_name_label(inputs)
	if (locale === "ja") return ja_markers_list_name_label(inputs)
	if (locale === "hi") return hi_markers_list_name_label(inputs)
	if (locale === "pt-PT") return pt_pt2_markers_list_name_label(inputs)
	return en_markers_list_name_label(inputs)
});